
define('app/dashboard/leagues/instances/views/lgInstanceView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickCollection',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/productModel',
	'app/dashboard/leagues/instances/views/lgInstAdvView',
	'app/dashboard/leagues/instances/views/lgInstSettingsView',
	'app/dashboard/leagues/instances/views/fantTeamView',
	'app/dashboard/leagues/instances/views/fantTeamAddView',
	'app/dashboard/leagues/instances/views/draftOrderView',
	'app/dashboard/leagues/instances/views/lgPositionsView',
	'app/dashboard/leagues/instances/views/scoringSettingsView',
	'app/dashboard/leagues/instances/views/lgUsersView'
], function(
		$, 
		_, 
		Backbone, 
		PickCollection,
		UserModel, 
		LeagueInstanceModel,
		ProductModel,
		LgInstAdvView,
		LgInstSettingsView, 
		FantTeamView,
		FantTeamAddView,
		DraftOrderView,
		LgPositionsView, 
		ScoringSettingsView,
		LgUsersView){
	var LgInstanceView = Backbone.View.extend({
		el: $("#lgInstContent"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance; 
			this.prodModel = options.prodModel;
			this.prodConfig = options.prodConfig;
			this.pickCollection = options.pickCollection;
			this.prodType = this.prodModel.get('productTypes').get(this.lgInstance.get("prodId"));
			this.refreshingTeams = false;
			
			_.bindAll(this, 'rearrangeTeamList');
			
			this.advView = new LgInstAdvView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodConfig: this.prodConfig,
				prodType: this.prodType});
			
			this.settingsView = new LgInstSettingsView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodConfig: this.prodConfig,
				prodType: this.prodType});
			
			this.addTeamView = new FantTeamAddView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodConfig: this.prodConfig,
				prodType: this.prodType});
			
			this.draftOrderView = new DraftOrderView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				pickCollection: this.pickCollection});
			
			this.lgUsersView = new LgUsersView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance});
			
			this.lgPositionsView = new LgPositionsView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodModel: this.prodModel,
				prodConfig: this.prodConfig,
				prodType: this.prodType});
			
			this.scoringSettingsView = new ScoringSettingsView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodModel: this.prodModel,
				prodConfig: this.prodConfig});
			
			
			this.listenTo(this.lgInstance, 'change', this.updateVisuals);
			//this.listenTo(this.lgInstance.get('fantasyTeams'), 'remove', this.updateVisuals);
			this.listenTo(this.lgInstance, 'add:fantasyTeams', this.addTeamChange);
			this.listenTo(this.lgInstance, 'remove:fantasyTeams', this.removeTeamChange);
			
			this.teamContainer = $(this.el).find('#fantTeamContainer');
			this.teamViews = [];
		},
		
		render: function () {
			this.updateVisuals();
			this.renderTeams();
			
			this.advView.render();
			this.settingsView.render();
			this.addTeamView.render();			
			this.draftOrderView.render();
			this.lgPositionsView.render();
			this.scoringSettingsView.render();
			this.lgUsersView.render();
			
			return this;
		},
		
		updateVisuals: function() {
			var prodStr = this.prodModel.prettyProdDesc(this.lgInstance.get("prodId"));			
			if(this.prodType.isTrial()){
				prodStr += ' Trial';
			}			
			if(_.size(this.prodModel.activePurchasableProducts()) > 0 
					&& this.lgInstance.isCommissioner(this.userModel.get('userName'))){
				prodStr += ' &mdash; <a href="/draftapp/dashboard/purchase">Upgrade</a>';
			}
			prodStr = '(' + prodStr + ')';
			
			$(this.el).find('#lgHeaderDispName').html(this.lgInstance.prettyDispName());
			$(this.el).find('#lgHeaderProd').html(prodStr);
			
			//Setup Board URL
			var fantTypeText = 'fantasy';			
			switch (this.lgInstance.get('prodLeagueName')) {
			case 'NFL':
				fantTypeText += ' football';
				break;
			case 'MLB':
				fantTypeText += ' baseball';
				break;
			case 'NBA':
				fantTypeText += ' basketball';
				break;
			case 'NHL':
				fantTypeText += ' hockey';
				break;
			default:
				break;
			}
			
			var facebookLink = 
				'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fclickydraft.com%2Fdraftapp%2Fboard%2F'
				+ this.lgInstance.get("id");
			
			var twitterLink = 
				'https://twitter.com/share?url=https%3A%2F%2Fclickydraft.com%2Fdraftapp%2Fboard%2F'
				+ this.lgInstance.get("id")
				+ '&via=ClickySports&text='
				+ encodeURIComponent('View our ' + fantTypeText + ' draft board: ');
			
			$(this.el).find('.socialBtnTwitter').attr("href", twitterLink);
			$(this.el).find('.socialBtnFacebook').attr("href", facebookLink);
			$(this.el).find('#draftUrl').html('https://clickydraft.com/draftapp/board/' + this.lgInstance.get('id'));
			
			//Determine whether to show the Invite Link
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				var inviteLink = 'https://clickydraft.com/draftapp/join?key='
					+ this.lgInstance.get('leagueName').toLowerCase()
					+ this.lgInstance.get('password').toLowerCase();
				
				$(this.el).find('#inviteUrl').html(inviteLink);
				$(this.el).find('#inviteUrlGrp').show();
			} else {
				$(this.el).find('#inviteUrlGrp').hide();
			}
		},
		
		renderTeams: function() {
			this.removeAllTeams();
			this.teamContainer.empty();
			this.addAllTeams();
		},
		
		addTeam: function(team) {
			var view = new FantTeamView({
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				fantTeam: team,
				prodType: this.prodType});
			this.listenTo(team, 'change:draftPosition', this.orderChange);
			this.teamContainer.append(view.render().el);
			//view.resetLeagues();
			this.teamViews[team.cid] = view;
		},
		
		addTeamChange: function(model) {
			this.addTeam(model);
			
			this.lgInstance.get("fantasyTeams").each(function(team){
				team.trigger("numTeamChange");
			}, this);
		},
		
		removeTeam: function(team) {
			this.stopListening(team, 'change:draftPosition', this.orderChange);
			this.teamViews[team.cid].destroyView();
			delete this.teamViews[team.cid];
		},
		
		removeTeamChange: function(model) {
			this.removeTeam(model);
			this.orderChange();
		},
		
		addAllTeams: function() {
			var teamList = this.lgInstance.getTeamList(); 
			_.each(teamList, function(team){
				this.addTeam(team);
			}, this);
		},
		
		removeAllTeams: function() {
			_.each(this.teamViews, function(view, key){
				this.teamViews[key].destroyView();
				delete this.teamViews[key];
			}, this);
		},
		
		orderChange: function() {
			if(!this.refreshingTeams){
				this.refreshingTeams = true;
				$(this.el).find('#refreshTeamListMessage').show();
				this.teamContainer.hide();
				this.lgInstance.get('fantasyTeams').fetch({success: this.rearrangeTeamList});
			}
		},
		
		rearrangeTeamList: function() {
			this.lgInstance.get("fantasyTeams").each(function(team){
				team.trigger("numTeamChange");
			}, this);
			
			for(var i = this.lgInstance.get('fantasyTeams').length; i > 0; i--) {
				var curTeam = this.lgInstance.getTeamByDraftPosition(i);
				this.teamContainer.prepend($(this.teamViews[curTeam.cid].el));				
			}
			
			$(this.el).find('#refreshTeamListMessage').hide();
			this.teamContainer.show();
			this.refreshingTeams = false;
		}
	});
	
	return LgInstanceView;  
});